import http from '@/utils/http';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';

const list = id => http.apiGet(`/category/course?id=${id}&uid=${getIdentity(IDENTITY_KEY_NAME.UID)}`);

export default {
  list,
};
